import { Observable } from 'rxjs';

import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class FsDetachNoAuthInterceptor implements HttpInterceptor {
  constructor() {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (request.headers.has('X-fs-no-auth')) {
      return next.handle(this._detachNoAuth(request));
    }
    return next.handle(request);
  }

  private _detachNoAuth(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      headers: request.headers.delete('X-fs-no-auth'),
    });
  }
}
